import { Illustration } from "../Illustration.js";
import { useTranslation } from "react-i18next";
import { jsx } from "react/jsx-runtime";

//#region src/components/illustration/variants/LocationFailedIllustration.tsx
const LocationFailedIllustration = (props) => {
	const { t } = useTranslation("phx-lib");
	return /* @__PURE__ */ jsx(Illustration, {
		...props,
		svgFile: "location-failed.svg",
		alt: t("illustration.imageAlt.locationFailed")
	});
};

//#endregion
export { LocationFailedIllustration };